module.exports = __webpack_public_path__ + "img/mega-wechat.a801a627.jpg";